<div class="flex flex-col h-full">
  <app-sidenav-header [title]="title"></app-sidenav-header>
  <div class="update-build pr-10 flex-1 overflow-y-auto">
    <form [formGroup]="updateBuildForm">
      <div class="flex justify-between">
          <div class="w-2/4">
              <div class="mat-body-2 fw-400">{{'INSTANCE_DETAILS.UPDATE_BUILD.ENVIRONMENT' | transloco}}</div>
              <div class="mat-body fw-500 pt-8">{{data?.name}}</div>
              <div class="mt-24">
                  <div class="mat-body-2 fw-400">{{'INSTANCE_DETAILS.UPDATE_BUILD.RELEASE_PACKAGE_VERSION' | transloco}}</div>
                  <div class="mat-body fw-500 pt-8">{{version?.version ? version?.version : '-'}}</div>
              </div>
          </div>
          <div class="w-2/4">
              <div class="mat-body-2 fw-400">{{'INSTANCE_DETAILS.UPDATE_BUILD.SERVICE_DEFINITION_VERSION' | transloco}}</div>
              <div *ngIf="selectedVersion?.version" class="mat-body fw-500 pt-8">{{'INSTANCE_SUMMARY.VERSION' | transloco}} {{selectedVersion?.version}}</div>
              <div *ngIf="!selectedVersion?.version" class="mat-body fw-500 pt-8">{{'-'}}</div>
          </div>
      </div>
      <mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
      <div class="flex justify-between">
          <div class="w-2/4">
              <div class="mat-body-2 fw-400">{{'INSTANCE_DETAILS.CURRENT_RELEASE_VERSION' | transloco}}</div>
              <div class="mat-body fw-500 pt-8 flex items-center">{{data?.releaseVersion? data?.releaseVersion: '-' }}
                <div *ngIf="solutionVersionsService.releaseVersion(data?.releaseVersion)" class="flex flex-row justify-center items-center vertical-dash pl-10 ml-10">
                  {{('INSTANCE_DETAILS.AMR' | transloco)}}
                </div>
              </div>
          </div>
          <div class="w-2/4">
              <div class="flex flex-row mat-body-2 fw-400">
                  {{'INSTANCE_DETAILS.UPDATE_BUILD.TARGET_RELEASE_VERSION' | transloco}}
                  <mat-icon svgIcon="info" class="icon-sm mt-2 ml-10" matTooltipClass="form-tooltip left" [matTooltip]="'INSTANCE_DETAILS.UPDATE_BUILD.TARGET_RELEASE_VERSION' | transloco"
                    matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
              </div>
              <div class="mat-body fw-500 pt-8">
                <ng-container *ngIf="!dropdownLoader; else dataLoaded">
                    <mat-spinner diameter="24" color="primary" mode="indeterminate"></mat-spinner>
                </ng-container>
                <ng-template #dataLoaded>
                  <mat-select class="fw-500 form-select version-selections" [formControl]="updateBuildForm.get('buildVersion')" placeholder="{{'INSTANCE_DETAILS.UPDATE_BUILD.CHOOSE' | transloco}}" [value]="selectedVersion" panelClass="version-selections" (click)="resetFilter()" (selectionChange)="getSelectedVersion($event.value)" (closed)="dropdownClose()">
                    <div class="flex search-bar m-8">
                      <span (click)="searchChanged(searchValue)" class="pt-4 w-26"><mat-icon class="mr-8 icon-sm icon-color ml-6 mt-4 mr-10" svgIcon="search"></mat-icon></span>
                      <input [formControl]="updateBuildForm.get('searchValue')" (ngModelChange)="onOptionsSelected(updateBuildForm.get('searchValue'))" class="fw-400 h-30 fs-14" placeholder="Search" type="text">
                    </div>
                    <mat-option *ngIf="versionData?.length === 0"> <div class="ml-16 mr-16 mt-8 mb-8 flex justify-center" *ngIf="versionData?.length === 0">{{'INSTANCE_DETAILS.UPDATE_BUILD.NO_VERSIONS_FOUND' | transloco}}</div></mat-option>
                    <mat-option *ngFor="let version of versionData" [value]="version?.version" [title]="version?.version" [ngClass]="{'group-title': version.group, 'group-items': !version.group}">{{version?.releaseVersion}}</mat-option>
                  </mat-select>
                  </ng-template>
              </div>
              </div>
          </div>
          <div>
          @if(showSizingDropdown && selectedVersion && !isAWS && isSizingApplicable) {
          <div class="flex flex-row mat-body-2 fw-400 mt-20">
              {{'TENANT_CONTINUOUS_UPDATE.SELECT_SIZING_DOCUMENT' | transloco}}
          </div>
          <div class="flex items-end">
            <mat-select class="fw-500 form-select version-selections" [formControl]="updateBuildForm.get('sizingDocument')" placeholder="{{'INSTANCE_DETAILS.UPDATE_BUILD.CHOOSE' | transloco}}" panelClass="version-selections" (click)="resetSizingDocFilter()" (closed)="sizingDropdownClose()">
              <div class="flex search-bar">
                <span (click)="sizingSearchChanged(sizingDropdownSearchValue)" class="pt-4 w-26"><mat-icon class="mr-8 icon-sm icon-color ml-6 mt-4 mr-10" svgIcon="search"></mat-icon></span>
                <input [formControl]="updateBuildForm.get('sizingDropdownSearchValue')" (ngModelChange)="onSizingDocOptionsSelected(updateBuildForm.get('sizingDropdownSearchValue'))" class="fw-400 h-30 fs-14" placeholder="Search" type="text">
              </div>
              <mat-option *ngIf="sizingDocuments?.length === 0"> <div class="ml-16 mr-16 mt-8 mb-8 flex justify-center" *ngIf="sizingDocuments?.length === 0">{{'SIZING.NO_SIZING_DOCUMENT_FOUND' | transloco}}</div></mat-option>
              <mat-option *ngFor="let document of sizingDocuments" [value]="document?.id" [title]="document?.name">{{document?.name}}</mat-option>
            </mat-select>
            @if(showCreateSizingLink) {
              <a class="hyperlink cursor-pointer ml-18 fw-500" (click)="openCreateSizingDialog()">{{'TENANT_CONTINUOUS_UPDATE.CREATE_SIZING_DOCUMENT' | transloco}}</a>
            }
          </div>
          }
      </div>
      <mat-divider *ngIf="data.packageReferenceId && addExternalOption" class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
          <div *ngIf="data.packageReferenceId && addExternalOption" class="flex items-center">
            <mat-icon [svgIcon]="externalSelected ? 'check_box' : 'check_box_outline_blank'" class="checkbox-icon icon-md" (click)="selectExternalTypes()"></mat-icon>
            <span class="pl-8 flex flex-row">{{'INSTANCE_DETAILS.UPDATE_BUILD.ADD_EXTERNAL_PACKAGE' | transloco}}<mat-icon svgIcon="info" class="icon-sm info-icon" (click)="externalPackageInfo()"></mat-icon></span>
          </div>
      <mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
      <div class="flex justify-between mat-body fw-500 pt-8">
          <div class="flex items-center w-2/4">
              <mat-icon svgIcon="radio_button_checked" class="radio-icon cursor-pointer"></mat-icon>
              <span class="pl-8">{{'INSTANCE_DETAILS.UPDATE_BUILD.UPDATE_NOW' | transloco}}</span>
          </div>
          <!-- <div class="flex items-center w-2/4">
              <mat-icon svgIcon="radio_button_unchecked" class="radio-icon cursor-pointer"></mat-icon>
              <span class="pl-8">{{'INSTANCE_DETAILS.UPDATE_BUILD.SCHEDULE_UPDATE' | transloco}}</span>
          </div> -->
      </div>
    </form>
  </div>
  <mat-divider class="mb-20 mt-20 neutral-2"></mat-divider>
  <div class="pt-4 pb-16">
    <div class="flex flex-row justify-between items-center gap-x-6">
      <div *ngIf="showWatchTutorial" class="flex flex-row items-center cursor-pointer watch-tutorial-btn" (click)="openUpgradeTutorial()">
        <mat-icon svgIcon="play_circle" class="icon-md mr-6"></mat-icon>
        <span class="fw-500 fs-14">{{'UPGRADE_VIDEO_TUTORIAL.WATCH_TUTORIAL' | transloco}}</span>
      </div>
      <div class="flex flex-row gap-x-6 ml-auto">
        <button class="white" type="button" (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' | transloco}}</button>
        <button class="accent" type="button" (click)="updateBuild()" [ngClass]="{'disabled': !isVersionAvailable || !updateBuildForm.get('buildVersion').value || (showSizingDropdown && !updateBuildForm.get('sizingDocument').value && isSizingApplicable)}">{{'BUTTONS.UPDATE' | transloco}}</button>
      </div>
    </div>
  </div>
</div>
